export class SeedCropLossLandingFilterVM {
  accountnumber: string;
  accountname: string;
  requestdaterange: string;
  requestId: string;
  productname: string;
  productnumber: string;
  growername: string;
  growergmk: string;
  customerPO: string;
  status: any;
}
